module.exports = __webpack_public_path__ + "static/media/07_CALCINHA_DE_AMARRAR_LISA_06.0fe79f79.jpg";